import { useState } from "react";
import { TextField, Button, Box, TableCell, TableHead, TableRow, TableBody, Table, Paper, TableContainer } from "@mui/material";
import AddIcon from '@mui/icons-material/Add'
import AddConditioningTestExercise from "./AddConditioningTestExercise.js";

const CreateConditioningTest = ({ exerciseList, names, submitHandler, handleCancel }) => {

    const [test, setCircuit] = useState({title: ''});
    const [exercises, setExercises] = useState([]);
    const [addingExercise, setAddingExercise] = useState(false);

    const handleFieldChange = (fieldName, e) => {
        if (e.target.value === '') {
            setCircuit({ ...test, [fieldName]: '' });
        } else {
            setCircuit({ ...test, [fieldName]: e.target.value });
        }
    };

    const handleNewExercise = (newExercise) => {
        setExercises([...exercises, newExercise]);
        setAddingExercise(false);
    }

    const preSubmit = () => {
        setCircuit((prev) => {
            const newCircuit = {
                ...prev,
                exercises: exercises
            };

            submitHandler(newCircuit);
            return newCircuit
        });
    }

    if (exerciseList?.length === 0) {
        return (
            <p className="p-style">Loading...</p>
        )
    }

    return (<>
        <div style={{position: 'fixed', top: '0', left: '0', right: 0, height: 'calc(100% - 56px)', backgroundColor: 'rgba(84, 84, 84, 0.7)'}}>
        </div>
        <div className="form-wrapper" style={{backgroundColor: 'var(--site-light-background-color)', padding: '0 5px', border: "2px solid var(--site-light-background-color)", borderRadius: '15px', width: '100%', position: 'absolute', zIndex: '1000'}}>
            <h2 className="h2-style">Create Test</h2>
            
            <TextField fullWidth style={{marginTop: '5px'}}
                type="text"
                id="title"
                label="Title"
                variant="outlined"
                value={test.title || ''}
                onChange={(e) => handleFieldChange('title', e)}
            />     

            <Box sx={{textAlign: 'center', margin: '10px 0', height: '33px', width: '100%'}}>
                <Button variant="contained" color="primary" style={{fontSize: '12px', color: 'var(--site-dark-text-color)'}} endIcon={<AddIcon />}  onClick={() => {setAddingExercise(true)}}>Add Exercise</Button>
            </Box>

            <TableContainer component={Paper} sx={{ marginTop: '20px', maxWidth: '400px', margin: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Exercise</TableCell>
                            <TableCell align="center">Metric</TableCell>
                            <TableCell align="center">Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {exercises?.map((cEx, index) => {
                            const exercise = exerciseList.find(
                                ex => ex.id === cEx.exercise_id && ex.type === cEx.exercise_type
                            );

                            return (
                                <TableRow key={index}>
                                    <TableCell>{exercise ? exercise.name : "Unknown Exercise"}</TableCell>
                                    <TableCell align="center">{cEx.metric}</TableCell>
                                    <TableCell align="center" style={{ maxWidth: 200, whiteSpace: 'normal', wordWrap: 'break-word' }}>{cEx.details}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <div className='bottom-buttons'>
                <Button
                    style={{margin: "10px 5px 5px", width: '100px'}}
                    disabled={!test.title?.length || !exercises?.length || names.includes(test.title?.toLowerCase())}
                    onClick={preSubmit}
                    variant="contained"
                >
                    Save entry
                </Button>

                <Button
                    style={{margin: "10px 5px 5px", width: '100px'}}
                    onClick={handleCancel}
                    variant="contained"
                >
                    Cancel
                </Button>
            </div> 
        </div>

        {addingExercise && 
            <AddConditioningTestExercise exerciseList={exerciseList} handleSubmit={handleNewExercise} handleCancel={() => setAddingExercise(false)} />
        }
        
    </>)
};

export default CreateConditioningTest;